export const TYPE_FIELD_VISIBLE_COUNT_ITEMS = 15
